export default __webpack_public_path__ + "static/upper-tract-diagram-1363c34e3413582ac11ae2e0ec4890d3.svg";